import React from 'react'
import { Space, Tag, Skeleton } from 'antd'
import Section from '../section/Section'
import useSWR from 'swr';
import ApiManager from '../../../business/services/ApiManager';
import { toDate } from '../../../helpers/dateFormatHelper';
import { useSelector } from 'react-redux';
import { RootState } from '../../../model/rootReducer';
import { Amount, Date } from './Styled';

type UpcomingInvoiceProps = {}

const UpcomingInvoice: React.FunctionComponent<UpcomingInvoiceProps> = ({ }) => {
    const { data, error } = useSWR(
        'Invoices/Upcoming', () =>
        ApiManager.customers.getUpcomingInvoices()
    )
    const bots = useSelector((state: RootState) => state.bot.bots)

    if (error) return <div>failed to load</div>
    if (!data) return <Skeleton active />
    
    return (
        <Section
            title="Prochaine facturation"
            subTitle="Ces montants sont susceptibles de changer suivant votre consommation"
        >
            <Space direction="vertical">
            {data.data.map((invoice: any) => {
                return (
                    <Space direction="horizontal">
                    <Amount>{invoice.amount/100} €</Amount>
                    <Date>le {toDate(invoice.nextPaymentAttempt)}</Date>
                    <Tag color="processing">{bots.find(x => x.id === invoice.botId)?.name}</Tag>
                </Space>
                )
            })}
            </Space>
        </Section>
    )
}

export default UpcomingInvoice
